import { BusinessSlug } from '../business-slug.enum';

export enum EtxeApiPrefixes {
  USER = `${BusinessSlug.ETXE}/user`,
  CORE = `${BusinessSlug.ETXE}/user`,
  PUBLIC = `${BusinessSlug.ETXE}/public`,
  ADMIN = `${BusinessSlug.ETXE}/admin`,
}

export enum EtxeApiSlugs {
  AGENT = 'agent',
  AGENTS = 'agents',
  AGENT_CARDS = 'agent-cards',
  PROPERTIES = 'properties',
  PROPERTY = 'property',
  OWNER = 'owner',
  GOUV = 'gouv',
  DISCUSSIONS = 'discussions',
  BETA_REGISTRATION = 'beta-registration',
  USERS = 'users',
  APPOINTMENTS = 'appointments',
  APPLICATIONS = 'applications',
}
